'use client'

import { useRouter } from 'next/navigation'
import { useLocale } from 'next-intl'
import { Button } from '@/components/button'
import { Locale } from '@/setup/locales'
import { getPathname, usePathname } from '@/setup/routing'
import { ILayoutProps } from '@/typings/layout-props'

export default function Layout({ children }: ILayoutProps) {
    const router = useRouter()
    const locale = useLocale()

    const pathname = usePathname()

    const translatedPathname = getPathname(pathname, undefined, locale as Locale)

    const partnerTermsAndConditionsPathname = getPathname(
        '/privacy-policy-partner',
        undefined,
        locale as Locale
    )
    const userTermsAndConditionsPathname = getPathname(
        '/terms-and-conditions',
        undefined,
        locale as Locale
    )

    return (
        <div className="min-h-dvh flex flex-col items-center">
            <div className="md:min-w-[70%] md:max-w-[70%] min-w-[90%] max-w-[90%]">
                <div className="flex gap-2 mt-8 justify-center">
                    <Button
                        styleType={
                            translatedPathname === userTermsAndConditionsPathname
                                ? 'primary'
                                : 'secondary'
                        }
                        onClick={() => {
                            router.push(userTermsAndConditionsPathname)
                        }}
                    >
                        Users
                    </Button>

                    <Button
                        styleType={
                            translatedPathname === partnerTermsAndConditionsPathname
                                ? 'primary'
                                : 'secondary'
                        }
                        onClick={() => {
                            router.push(partnerTermsAndConditionsPathname)
                        }}
                    >
                        Partners
                    </Button>
                </div>

                {children}
            </div>
        </div>
    )
}
